import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { SnackbarComponent } from "../snackbar.component";

@Component({
  selector: "app-warning-message",
  imports: [MatIconModule, TranslateModule],
  templateUrl: "./warning-message.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./warning-message.component.less",
})
export class WarningMessageComponent extends SnackbarComponent<string> {
  public constructor() {
    super();
  }
}
